"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuSearchResultBlockVariant = void 0;
var MenuSearchResultBlockVariant;
(function (MenuSearchResultBlockVariant) {
    MenuSearchResultBlockVariant["SUGGESTIONS"] = "keywords";
    MenuSearchResultBlockVariant["CONTENT"] = "content";
    MenuSearchResultBlockVariant["BRANDS"] = "brands";
    MenuSearchResultBlockVariant["CATEGORIES"] = "categories";
    MenuSearchResultBlockVariant["BRAND_AS_CATEGORIES"] = "brand_as_categories";
})(MenuSearchResultBlockVariant || (exports.MenuSearchResultBlockVariant = MenuSearchResultBlockVariant = {}));
//# sourceMappingURL=MenuSearchTypes.js.map